export default {
    namespaced: true,
    state: {
        items: [],
        x: 0,
        y: 0
    },
    getters: {
        items(state) {
            return state.items;
        },
        x(state) {
            return state.x;
        },
        y(state) {
            return state.y;
        },
    },
    mutations: {
        set(state, {items, x = 0, y = 0}) {
            state.items = items;
            state.x = x;
            state.y = y;
        }
    },
    actions: {}
}